export default __webpack_public_path__ + "static/thin-cup-red-9b7310948764dbc087d9815fe4cba2aa.png";